// Module
var code = "<input class=\"form-control\" type=\"{{ vm.field.isRedacted ? 'password' : 'text' }}\" ng-model=\"vm.value\" id=\"fieldresponse_{{vm.fieldResponse.id}}\" placeholder=\"{{ vm.requiredPlaceholderText | lowercase }}\"> ";
// Exports
module.exports = code;